import React  from 'react';
import MentorsInfoComponent from './mentor-info.component';
import MentorsAddressComponent from './mentor-primary-address-info.component';
import MentorsUserProfileInfoComponent from './mentor-user-profile-info.component';
import MentorsAccountInfoComponent from './mentor-account-info.component';
import TabContainer from '../../../../common/components/tab/containers/tab.containers';
import MentorsBasicInfoComponent from './mentor-basic-info.component';



export const MentorsComponent = ({handleBasicFormChange, selectedAddress,handleInnerFormChange,id,changeImage,tagNames,selectedMentors,back,handleFormSubmit,}: any) => {
  const tabItems=[

     {
            id:1,
            title:'Mentor Details',
            component:<MentorsBasicInfoComponent 
            handleInnerFormChange={handleInnerFormChange}
            selectedMentors={selectedMentors}
            id={id}
            tagNames={tagNames}
           />,
        isVisible:true,
        },
    
    {
      id:1,
      title:'Account Info',
      component:<MentorsAccountInfoComponent 
      handleInnerFormChange={handleInnerFormChange}
      selectedMentors={selectedMentors}
      handleBasicFormChange={handleBasicFormChange}
     />,
  isVisible:true,
  },
    {
        id:2,
        title:'User Profile',
        component:<MentorsUserProfileInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedMentors={selectedMentors}
       />,
    isVisible:true,
    },
    {
      id: 3,
      title: 'Address',
      component: <MentorsAddressComponent
        onInnerFormChange={handleInnerFormChange}
        selectedAddress={selectedAddress}
      />,
      isVisible: true,
    },

    

     {
        id:4,
        title:'Mentors Info',
        component:<MentorsInfoComponent 
        handleInnerFormChange={handleInnerFormChange}
        selectedMentors={selectedMentors}
        tagNames={tagNames}
        changeImage={changeImage}
       />,
    isVisible:true,
    },
   

  ]
    
  return (
    <div className="flex flex-col items-center w-full px-5 h-[620px] overflow-auto">
       
     
      <TabContainer tabItems={tabItems} />
   
      <div className='flex w-full justify-end items-end'>
        <button
              onClick={back}
              type='button'
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
             >
              Back
             </button>
             <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
              onClick={handleFormSubmit}
            
              type="submit"
          >
            Save
          </button>
        </div>
       </div>
  )
}
export default MentorsComponent;
